"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getDateTime = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dateFns = require("date-fns");

var _locale = require("date-fns/locale");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var locales = {
  nb: _locale.nb,
  en: _locale.enGB,
  nn: _locale.nb
};

var getDateTime = function getDateTime(dateTime, format, locale, parseFormat) {
  return (0, _dateFns.format)(parseFormat ? (0, _dateFns.parse)(dateTime, parseFormat, new Date()) : dateTime, format || 'Pp', {
    locale: locale in locales ? locales[locale] : _locale.nb
  });
};

exports.getDateTime = getDateTime;

var DateTime = function DateTime(_ref) {
  var dateTime = _ref.dateTime,
      format = _ref.format,
      locale = _ref.locale,
      parseFormat = _ref.parseFormat;
  return _react.default.createElement("span", null, getDateTime(dateTime, format, locale, parseFormat));
};

DateTime.propTypes = {
  /** Dato-streng på en eller annen form. Eller dato-objekt.
   * Om en er på en annen form enn ISO må format spesifiseres i `parseFormat`-prop-en */
  dateTime: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.instanceOf(Date)]).isRequired,

  /** Format på output */
  format: _propTypes.default.string,

  /** Localisering, støttet nå er: en (Britisk), nb (Norsk), nn (Samme som nb) */
  locale: _propTypes.default.string,

  /** Valgfri prop som forteller komponenten hvordan den skal tolke den innkommende dato-verdien.
   * Om den inkommende verdien er på ISO-format trenger ikke denne spesifiseres.
   */
  parseFormat: _propTypes.default.string
};
DateTime.defaultProps = {
  format: 'Pp',
  locale: 'nb',
  parseFormat: ''
};
var _default = DateTime;
exports.default = _default;